<template>
    <div class="padding-10">
        <a-divider orientation="left">集团管理</a-divider>
        <div class="table-tools-right">
            <a-button type="primary" @click="initTable">查询</a-button>
            <a-button-group >
                <a-button  @click="initTable"><i class="fa fa-refresh icon"></i>  刷新</a-button>
                <a-button type="primary" @click="add"><i class="fa fa-plus icon"></i>  新增</a-button>
            </a-button-group>
        </div>
        <a-table :loading="loading"
                 :columns="columns"
                 :dataSource="data"
                 bordered
                 @change="changeOrder"
                 :pagination="pagination"
        >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>
                   <span slot="option" slot-scope="text, record, index">
                        <template>
                            <div class="btn">
                                <span class="badge-success" @click="edit(record)">编辑</span>
                                <a-popconfirm
                                        title="真的要删除该集团吗？"
                                        @confirm="confirm(record)"
                                        okText="是"
                                        cancelText="否"
                                >
                                    <span class="badge-danger" >删除</span>
                                </a-popconfirm>

                            </div>
                        </template>
                  </span>
        </a-table>

        <a-modal title="添加集团" v-model="addModel.visible" @ok="handleOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="form" layout="inline">
                        <a-row :gutter="12">
                            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, message: '集团名称不能为空' }] }]" />
                            </a-form-item>
                            <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['address', { rules: [{ required: true, message: '地址不能为空' }] }]"/>
                            </a-form-item>
                            <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                <a-input v-decorator="['description', { rules: [{ required: false, message: '描述不能为空' }] }]"/>
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>

        <a-modal title="修改集团" v-model="editModel.visible" @ok="handleEditOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="editForm" layout="inline">
                        <a-row :gutter="12">
                            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, message: '集团名称不能为空' }] }]" />
                            </a-form-item>
                            <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['address', { rules: [{ required: true, message: '地址不能为空' }] }]"/>
                            </a-form-item>
                            <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                <a-input v-decorator="['description', { rules: [{ required: false, message: '描述不能为空' }] }]"/>
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>


    const columns = [
        {
            title: 'id',
            key: 'id',
            dataIndex: 'id',
            sorter: true,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '名称',
            key: 'name',
            dataIndex: 'name',
            sorter: true
        },

        {
            title: '地址',
            key: 'address',
            dataIndex: 'address',
            sorter: true
        },
        {
            title: '描述',
            key: 'description',
            dataIndex: 'description',
            show: true,
            sorter: true
        },
        {
            title: '创建时间',
            key: 'createTime',
            dataIndex: 'createTime',
            sorter: true
        },
        {
            title: '操作',
            key: 'option',
            dataIndex: 'option',
            sorter: true,
            scopedSlots: {customRender: "option"},
            width: 150,
        }


    ];
    export default {
        name: "group",
        data(){
            return {
                labelCol: {
                    span: 4
                },
                columns,
                data: [],
                form: this.$form.createForm(this),
                editForm: this.$form.createForm(this),
                queryParam:{
                    address: '',
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'asc',
                    page: 1,
                    size: 10
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                pagination: {
                    total: 0,
                    current: 1,
                    // defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10','20','50','100']
                },
                addModel:{
                    visible: false,
                    name: '',
                    address: '',
                    desc: ''
                },
                editModel:{
                    visible: false,
                    obj: null,
                }
            }
        },
        mounted(){
            this.initTable();
        },

        methods:{
            async initTable(){
                this.loading = true;
                let result = await this.$http.get(this.$baseURL.groupPage({address: this.address}, this.queryParams));
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;

                console.log(this.pagination)
            },

            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'asc';
                this.initTable()
            },

            add(){
                this.addModel.visible = true;
            },

            handleOk(e){
                e.preventDefault();
                const { form: { validateFields }} = this;
                validateFields(["name", "address", "description"], { force: true }, (err, values) => {
                    if (!err) {
                        let loginParams = { ...values }
                        console.log(loginParams)
                        this.addGroup(loginParams)
                    }
                })
            },
            async addGroup(obj){
                await this.$http.postJson(this.$baseURL.manageGroup(), obj);
                this.$Utils.showSuccess({title: '添加成功'});
                this.addModel.visible = false;
                this.initTable();
            },
            /**********编辑**********/

            edit(data){
                //console.log(data);
                this.editModel.visible = true;
                this.editModel.obj = data;
                this.$nextTick(()=>{
                    this.editForm.setFieldsValue({
                        'name': data.name,
                        'address': data.address,
                        'description': data.description
                    })
                })

            },

            handleEditOk(e){
                e.preventDefault();
                const { editForm: { validateFields }} = this;
                validateFields(["name", "address", "description"], { force: true }, (err, values) => {
                    if (!err) {
                        let params = { ...values }
                        this.editGroup(params)
                    }
                })
            },
            async editGroup(obj){
                obj.id = this.editModel.obj.id;
                await this.$http.putJson(this.$baseURL.manageGroup(), obj);
                this.$Utils.showSuccess({title: '修改成功'});
                this.editModel.visible = false;
                this.initTable();
            },
            /************删除*************/
            async confirm(data){
                console.log(data)
                await this.$http.deleteJson(this.$baseURL.deleteGroupById(data.id));
                this.$Utils.showSuccess({title: '删除成功'});
                this.initTable();
            }


        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style lang="less" scoped>

    .table-tools-right {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    .icon{
        margin-right: 5px;
    }
    .btn {
        span{
            display: inline-block;
            padding: 3px 10px;
            margin-right: 5px;
            &:hover{
                cursor: pointer;
            }
        }
        .badge-success:hover {
            background: #1890ff;
        }

        .badge-danger:hover{
            background: #ed3543;
        }

    }
</style>
